// eslint-disable-next-line import/prefer-default-export
export const NO_ACCESS_TITLE = "[No access]";
